export { GLOBAL_NAV_KEY, GLOBAL_NAV_PARAM, GLOBAL_NAV_CONTENT} from '../Header/Constants';

export const testAttributes = {
    PAGE_ROOT: 'layout_root_container',
    MAIN_CONTAINER: 'layout_main_container',
    MAIN_BREADCRUMB_CONTAINER: 'layout_main_breadcrumb_container',
};

export const classNames = {
    ...testAttributes
};